// extracted by extract-css-chunks-webpack-plugin
module.exports = {"splitter":"splitter-1STPx","outline":"outline-SYyps"};